(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ow-offer-gifts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('osteane-gifts')) {
    customElements.define('osteane-gifts', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        if (this.dataset.mode !== 'countdown') return;
        const deadline = this.dataset.deadline.trim();
        if (!/T.*(Z|[+-]\d{2}:\d{2})$/.test(deadline)) return;
        const end = Date.parse(deadline);
        if (!Number.isFinite(end)) return;
        const clock = this.querySelector('[data-offer-timer]');
        const banner = this.querySelector('[data-offer-banner]');
        if (!clock || !banner) return;
        const tick = () => {
          const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
          if (!remaining) { banner.hidden = true; clearInterval(this.timer); return; }
          const hours = Math.floor(remaining / 3600).toString().padStart(2, '0');
          const minutes = Math.floor(remaining % 3600 / 60).toString().padStart(2, '0');
          const seconds = (remaining % 60).toString().padStart(2, '0');
          clock.textContent = hours + ':' + minutes + ':' + seconds;
          clock.dateTime = this.dataset.deadline;
          clock.hidden = false;
          banner.hidden = false;
        };
        tick();
        if (!banner.hidden) this.timer = setInterval(tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
